import React from "react";

import Select from "react-select";
import { destinationSortOptions } from "./destinationSortOptions";

const defatulOption = { value: "default", label: "--Sort by--" };

const DestinationsPropertiesSort = ({ handleSort, selectedSort }) => {
  return (
    <Select
      name="sort"
      id="sort-list"
      className="basic-single"
      classNamePrefix="select"
      options={destinationSortOptions}
      defaultValue={defatulOption}
      value={destinationSortOptions.find((obj) => obj.value === selectedSort) || defatulOption}
      onChange={(e) => {
        handleSort(e.value);
      }}
      selected={selectedSort}
      isSearchable={false}
      styles={{
        container: (provided) => ({
          ...provided,
          width: "240px",
          height: "36px",
          zIndex: 11,
        }),
        control: (provided) => ({
          ...provided,

          border: "1px solid #E6E6E6 !important",

          boxShadow: "none",
        }),

        menuList: (provided) => ({
          ...provided,
          maxHeight: "none",

          "&::-webkit-scrollbar": {
            width: "8px",

            "&-track": {
              backgroundColor: "transparent",
            },
            "&-thumb": {
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "10px",
            },
          },
        }),

        option: (provided, state) => ({
          ...provided,
          fontSize: "14px",
          borderBottom: "1px solid #F2F2F2",
          backgroundColor: state.isSelected ? "#8080ad" : "white",
          // handle focus state
          ":active": {
            ...provided[":active"],
            backgroundColor: "#8080ad",
          },
          ":hover": {
            ...provided[":hover"],
            backgroundColor: state.isSelected ? "#8080ad" : "var(--clr-light)",
          },
        }),

        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none",
        }),
      }}
    />
  );
};

export default DestinationsPropertiesSort;
